import { Fragment, ReactElement, useContext } from "react"

import { IStep } from "../../../interfaces/markets"

import { DataUploadContext } from "../../../providers/DataUploadContext"

type Props = {
  steps: IStep[]
  currentStep: number
}

const ProgressStepper = ({ steps, currentStep }: Props): ReactElement => {
  const { completedStep } = useContext(DataUploadContext)

  const getStatusLabel = (id: number): string => {
    if (id <= completedStep || id < currentStep) return "completed"
    if (id === currentStep) return "in progress"
    return "pending"
  }

  const getStatusColor = (id: number): string => {
    if (id < currentStep || (id !== currentStep && id <= completedStep)) return "text-teal-500"
    if (id === currentStep) return "text-[var(--interactive-01)]"
    return "text-gray-400"
  }

  const ConnectorLine = ({ fromStep }: { fromStep: number }): ReactElement => {
    const isCompleted = fromStep < currentStep || fromStep <= completedStep
    const isCurrent = fromStep === currentStep

    return (
      <div className="flex-1 h-1 bg-blue-200 rounded-full overflow-hidden xl:mx-4 mx-1">
        {isCompleted && <div className="h-full w-full bg-teal-500 transition-all duration-300" />}
        {isCurrent && <div className="h-full w-1/2 bg-[var(--interactive-01)] transition-all duration-300" />}
      </div>
    )
  }

  return (
    <div className="w-full">
      <div className="flex items-center w-full justify-between">
        {steps.map((item, index) => (
          <Fragment key={item.id}>
            <div className="flex flex-col px-2">
              <div className={`text-xs mb-1 font-bold uppercase ${getStatusColor(item.id)}`}>STEP {index + 1}</div>
              <div className={`text-md mb-0.5 font-bold ${getStatusColor(item.id)}`}>{item.label}</div>
              <div className="text-xs text-gray-500 mt-0.5">{item.description}</div>
              <div className={`text-xs mt-0.5 font-bold capitalize ${getStatusColor(item.id)}`}>
                {getStatusLabel(item.id)}
              </div>
            </div>

            {index < steps.length - 1 && <ConnectorLine fromStep={item.id} />}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export default ProgressStepper
